"use strict";
import { useMutation } from "@tanstack/react-query";
import { useModalState } from "hooks/useModalState";
import { atom } from "jotai";
import { useUpdateAtom } from "jotai/utils";
import { PasskeysHelpModalTypes } from "features/passkey/PasskeysHelpModal";
import { ModalName } from "features/telemetry/constants";
import { logger } from "utilities/src/logger/logger";
export const PasskeysHelpModalTypeAtom = atom(PasskeysHelpModalTypes.Default);
export function usePasskeyAuthWithHelpModal(mutationFn, options) {
  const { openModal: openPasskeysHelpModal } = useModalState(ModalName.PasskeysHelp);
  const setPasskeysHelpModalType = useUpdateAtom(PasskeysHelpModalTypeAtom);
  return useMutation({
    mutationFn,
    ...options,
    onError: (error, variables, context) => {
      const errorContext = {
        variables,
        context,
        message: "",
        type: PasskeysHelpModalTypes.Default
      };
      let errorType = PasskeysHelpModalTypes.Default;
      const uuidRegex = /[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/;
      if (error instanceof Error && uuidRegex.test(error.message)) {
        if (error.message.includes("not_found")) {
          errorType = PasskeysHelpModalTypes.InvalidPasskey;
        } else {
          errorType = PasskeysHelpModalTypes.TechnicalError;
        }
        errorContext.message = error.message;
        errorContext.type = errorType;
      }
      setPasskeysHelpModalType(errorType);
      logger.error(error, {
        tags: {
          file: "usePasskeyAuthWithHelpModal",
          function: mutationFn.name
        },
        extra: errorContext
      });
      openPasskeysHelpModal();
      options?.onError?.(error, variables, context);
    }
  });
}
